import script from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocaleSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=3847b2ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3847b2ee"]])

export default __exports__